import React from 'react';
import DaySummaryForm from '../components/daily-planner/DaySummaryForm';

const DaySummaryPage = () => {
  return <DaySummaryForm />;
};

export default DaySummaryPage;
